<template>

<div class="files-upload">
    
    <div class="list">
        <div class="file" v-for="file in files" :key="file.id" 
            :class="{
                'file-sm':size=='sm','file-xs':size=='xs',
            }">
            <!-- <div class="thumb" v-if="file.type=='image'" :style="'background-image:url('+API_URL+file.urlThumb+')'"></div> -->
            
            <a class="thumb thumb-document" 
                v-if="file.type=='document'"
                :href="API_URL+file.url" target="_blank" 
                ><i class="fa fa-file-o"></i>
            </a>
            <a class="filename"
                v-if="file.type=='document'"
                :href="API_URL+file.url" target="_blank" 
            >{{file.filename}}.{{file.extension}}</a>

            <div class="thumb"
                v-if="file.type=='image'"
                :style="'background-image:url('+API_URL+file.urlThumb+')'"
                @click="showLightbox(file)"
                >
            </div>
            <div class="filename" v-if="file.type=='image'" @click="showLightbox(file)">{{file.filename}}.{{file.extension}}</div>
            

            <!-- <div class="btn btn-delete" @click="remove(index)"><i class="icon icon-sm icon-close"></i></div> -->
        </div>
    </div>

    <FsLightbox
        :toggler="toggler"
        :sources="images"
        :slide="slide"
    ></FsLightbox>

</div>
</template>

<script>
import FsLightbox from "fslightbox-vue";

export default {
    name: "fileList",
    components: {
        FsLightbox
    },
	props:{
		files:{
            type: Array,
        },
        size:{
            type: String
        }
    },
    data() {
        return {
            API_URL: process.env.VUE_APP_API_URL,
            toggler: false,
            slide: 1
        }
    },
    computed: {
        images() {
            let images =  this.files.filter(c => c.type=='image')
            return images .map(image => {
                return this.API_URL+image.url
            })
        }
    },
	methods:{
        showLightbox(file){
            // busco el archivo que quiero abrir en el array de images
            let index = this.images.findIndex( url => { 
                return url == this.API_URL+file.url
            })
            this.slide = index+1
            this.toggler = !this.toggler
        },
		remove(index){
            this.value.splice(index,1)
            this.$emit('changed')
        },
	}
};
</script>

<style scoped lang="scss">

.list{
    width: 100%;
    display: flex;
    flex-direction: column;

    .file{
        width: 100%;
        border: 1px solid rgba(28,110,164,.2);
        margin: 4px 0;
        padding: 4px;
        border-radius: 3px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-grow: 0;
        flex-shrink: 0;   
        cursor: pointer;

        .filename{
            flex-grow: 1;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .btn-delete{
            color: #000;
        }
    }
}
.thumb{
    border-radius: 3px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 48px;
    height: 48px;
    margin-right: 8px;
}

.thumb-document{
    background-color: #ccc;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    i{
        font-size: 18px;
        color: #fff;
    }
}

.file-sm{
    .thumb{
        width: 30px;
        height: 30px;
    }
    .thumb-document i{
        font-size: 12px;
    }
}

.file-xs{
    border: none !important;
    padding: 2px !important;

    .thumb{
        width: 22px;
        height: 22px;
    }
    .thumb-document i{
        font-size: 10px;
    }
}

</style>
